/**
 * @description B端商业化联系销售容器
 * @author liushuai
 */

import './whitePaper.scss';
import React from 'react';
import { WhitePaperBanner } from './components/@whitePaperBanner/whitePaperBanner';
import { WhitePaperContent } from './components/@whitePaperContent/whitePaperContent';
interface IProp {
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
    hasSubmitted: boolean;
    changeHasSubmitted: Function;
}
export const WhitePaper = (props: IProp) => {
    return (
        <div className="white-paper">
            <WhitePaperBanner {...props} />
            <WhitePaperContent {...props} />
        </div>
    );
};
